// extracted by mini-css-extract-plugin
export default {"expandingAreaWrapper":"_22b13c8c","description":"_adfdee8","readMoreButton":"_9c7329df"};